import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { sparseSegmentSchema } from "../shared/sparseSegmentSchema";
import { audienceDescriptionHashSchema } from "../shared/audienceDescriptionHashSchema";
import { filtersGetSchema, exclusionFiltersGetSchema } from "../filter/filtersGetSchema";

export const decisionSplitGetSchema = z.object({
  id: common.objectId,
  name: z.null(), // Always null for decision splits.
  next: common.objectId.nullable(),
  exits_canvas: z.null(), // Always null for decision splits.
  audience_description_hash: audienceDescriptionHashSchema,
  exclusion_filters: exclusionFiltersGetSchema,
  filters: filtersGetSchema,
  segments_data_array: z.array(sparseSegmentSchema),
  should_show_read_only_sentences: z.literal(false),
  using_v2_filters: z.boolean().nullable().optional(),
});

export const decisionSplitStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("DECISION_SPLIT"),
  step_data: z.object({
    decision_splits: z.array(decisionSplitGetSchema),
  }),
});
